export default "__VITE_ASSET__BoKAIbGg__"